import { Control } from "react-hook-form";
import { InventoryProductSpecificationValues } from "../inventory-product-specification-form.component";
import Grid from "@mui/material/Grid";
import InputFormField from "components/input-form-field";

export type DomeSpecificationValues = {
  size?: string;
  type?: string;
  additional_notes: string;
};

export const EMPTY_DOME_SPECIFICATION: DomeSpecificationValues = {
  additional_notes: "",
  size: "",
  type: "",
};

type DomeSpecificationFormProps = {
  control: Control<InventoryProductSpecificationValues, object>;
};

export default function DomeSpecificationForm({
  control,
}: DomeSpecificationFormProps) {
  return (
    <Grid
      container
      width="100%"
      sx={{ pb: 4 }}
      columnSpacing={2}
      rowSpacing={4}
    >
      <Grid item xs={6}>
        <InputFormField
          name="dome.type"
          label="Type"
          control={control}
          sx={{ ml: 0 }}
        />
      </Grid>
      <Grid item xs={6}>
        <InputFormField
          name="dome.size"
          label="Size"
          control={control}
          sx={{ ml: 0 }}
        />
      </Grid>
      <Grid item xs={12}>
        <InputFormField
          name="dome.additional_notes"
          label="Additional notes"
          control={control}
          sx={{ ml: 0 }}
          multiline
        />
      </Grid>
    </Grid>
  );
}
